import store from '@monolith/legacy/store';

export default function loadCarts(to) {
  const pagesWithCarts = ['product', 'brand', 'search', 'brand-collection', 'connected'];
  const isPageRequiredCarts = pagesWithCarts.includes(to.name);
  const isCartLoading = store.getters['cart/isCartLoading'];
  const isRetailer = store.getters.userIsRetailer;

  if (isRetailer && isPageRequiredCarts && !isCartLoading) {
    store.dispatch('cart/getCurrentCheckout');
  }
}
